import { render, staticRenderFns } from "./TransferPickupModal.vue?vue&type=template&id=1400d950&scoped=true&"
import script from "./TransferPickupModal.vue?vue&type=script&lang=ts&"
export * from "./TransferPickupModal.vue?vue&type=script&lang=ts&"
import style0 from "./TransferPickupModal.vue?vue&type=style&index=0&id=1400d950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1400d950",
  null
  
)

export default component.exports